import classNames from 'classnames';

import Card from './Card';
import TextBlock from '../TextBlock/TextBlock';
import SectionTitle from '../SectionTitle/SectionTitle';

import styles from './CardBlock.module.scss';

const CardBlock = ({
  data,
  className,
  gridValue,
  icon,
  linkClassName,
  withoutTitle,
}) => {
  const getGridClass = (() => {
    const formattedString = String(gridValue);

    switch (formattedString) {
      case '3':
        return styles['card-block__inner--three'];
      case '4':
        return styles['card-block__inner--four'];
      default:
        return '';
    }
  })();

  const renderCardItem = (item, index) => {
    return (
      <Card
        data={item}
        key={index}
        point={index + 1}
        icon={icon}
        linkClassName={linkClassName}
      />
    );
  };

  return (
    <section
      className={classNames([styles['card-block'], className])}
      itemScope
      itemType='https://schema.org/Offer'
    >
      {!withoutTitle && (
        <>
          {data?.title && (
            <SectionTitle className={styles.cardTitle} isHtml>
              {data.title}
            </SectionTitle>
          )}
          {data?.description && data.description.trim() !== '' && (
            <TextBlock
              titleModify={classNames([styles['card-block_title_desc']])}
              isHtml
            >
              {data.description}
            </TextBlock>
          )}
        </>
      )}
      <div className={classNames([styles['card-block__inner'], getGridClass])}>
        {(data?.items || data?.cards)?.map(renderCardItem)}
      </div>
    </section>
  );
};

export default CardBlock;
